function SettingsProfileCard({ profileImage, profileName, profileEmail, appTheme }) {  return (
    <div
      style={{
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "16px 18px",
        background: appTheme.cardBackground,
        borderRadius: "24px",
        border: appTheme.cardBorder,
        overflow: "hidden"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          minWidth: 0
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "999px",
            overflow: "hidden",
            background: profileImage
              ? appTheme.cardBackground
              : appTheme.accentLight,
            border: appTheme.accentBorder,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: appTheme.accentColor,
            fontSize: "24px",
            fontWeight: "700",
            flexShrink: 0
          }}
        >
          {profileImage ? (
            <img
              src={profileImage}
              alt="Profile"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center top"
              }}
            />
          ) : (
            (() => {
              const parts = (profileName || "").trim().split(/\s+/).filter(Boolean);
              if (parts.length === 0) return (
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
              );
              const initials = parts.length >= 2
                ? parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase()
                : parts[0][0].toUpperCase();
              return initials;
            })()
          )}
        </div>

        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontSize: "15px",
              fontWeight: "500",
              fontFamily: appTheme.fontHeading,
              color: appTheme.primaryText,
              lineHeight: 1.2,
              marginBottom: "4px"
            }}
          >
            {profileName.split(" ")[0]}
          </div>

          <div
            style={{
              fontSize: "13px",
              color: appTheme.secondaryText,
              lineHeight: 1.4,
              wordBreak: "break-word"
            }}
          >
            {profileEmail}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingsProfileCard;